import type {AxiosError} from "axios";

import {GENERIC_AMENITY_RESTRICTION_MESSAGE} from "./household-amenity-restriction";
import {RESIDENT_GENERIC_AMENITY_RESTRICTION_MESSAGE} from "@/src/modules/home/lib/resident-amenity-restriction-copy";

type ApiErrorBody = {error_code?: string; message?: string};

function getRestrictionErrorBody(error: unknown): ApiErrorBody | undefined {
  return (error as AxiosError<ApiErrorBody>)?.response?.data;
}

export function isHouseholdAmenityRestrictionError(
  error: unknown,
): error is AxiosError<ApiErrorBody> {
  return getRestrictionErrorBody(error)?.error_code === "household_amenity_access_restricted";
}

/** Staff-facing toast copy — does not surface API resident_message. */
export function getHouseholdAmenityRestrictionErrorMessage(_error: unknown): string {
  return GENERIC_AMENITY_RESTRICTION_MESSAGE;
}

/** Resident-facing toast copy — prefers API `message` from blocked create attempts. */
export function getResidentHouseholdAmenityRestrictionErrorMessage(error: unknown): string {
  const message = getRestrictionErrorBody(error)?.message?.trim();
  return message || RESIDENT_GENERIC_AMENITY_RESTRICTION_MESSAGE;
}
